import {useDispatch, useSelector} from 'react-redux';
import type {AppDispatch, RootState} from './index.ts';

// Typed wrappers around the raw react-redux hooks. Components must import these
// (enforced by the no-restricted-imports lint rule) so dispatch/selector calls
// are fully typed against the app's store.
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
